export const APPROVEMENTS_DRIVER = 'APPROVEMENTS_DRIVER'
export const APPROVEMENTS_AUTO = 'APPROVEMENTS_AUTO'
export const APPROVEMENTS_CONTRAGENTS = 'APPROVEMENTS_CONTRAGENTS'
